import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchFeatureSwitchByMultipleValuesRequest } from "../../store/FeatureSwitchByMultipleValues/FeatureSwitchByMultipleValuesSlice";

const UseFeatureSwitch = (itemsPayload) => {
    const dispatch = useDispatch();
    const {
        featureSwitchByMultipleValues: featureSwitchValues, 
        loading: featureSwitchAPILoading,
        error: featureSwitchAPIError,
        success: featureSwitchAPISuccess
    } = useSelector((state) => state.FeatureSwitchByMultipleValues);

    useEffect(() => {
        dispatch(fetchFeatureSwitchByMultipleValuesRequest(itemsPayload))
    }, [dispatch, itemsPayload]);

    return {
        featureSwitchValues, 
        featureSwitchAPILoading, 
        featureSwitchAPIError,
        featureSwitchAPISuccess
    };
}

export default UseFeatureSwitch;